var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33364 23.0558C8.87531 23.0558 8.48295 22.8926 8.15657 22.5662C7.83018 22.2399 7.66699 21.8475 7.66699 21.3892V11.3893C7.66699 10.931 7.83018 10.5386 8.15657 10.2122C8.48295 9.88585 8.87531 9.72266 9.33364 9.72266H14.3336L16.0002 11.3893H22.6668C23.1251 11.3893 23.5175 11.5525 23.8439 11.8789C24.1703 12.2053 24.3335 12.5976 24.3335 13.0559V21.3892C24.3335 21.8475 24.1703 22.2399 23.8439 22.5662C23.5175 22.8926 23.1251 23.0558 22.6668 23.0558H9.33364ZM9.33364 21.3892H22.6668V13.0559H15.3127L13.6461 11.3893H9.33364V21.3892Z",
    fill: "#0A8BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemFiles);
export default __webpack_public_path__ + "static/media/system_files.87529a7da2bb3ba5d3a93915c2555d38.svg";
export { ForwardRef as ReactComponent };